import React, { useState, useEffect, useRef } from "react";
import styles from "./event.module.css";
// import jumpboy from "../../assets/images/jumpboy.png";
import school from '../../assets/images/school.png';
const Birthday = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [apiResponse, setApiResponse] = useState('');
    const bannerRef = useRef(null);
    const requestRef = useRef();

    const callAPI = () => {
        fetch("http://localhost:4000/testAPI")
            .then(res => res.text())
            .then(res => setApiResponse(res))
    }

    useEffect(() => {
        function handleScroll() {
            requestRef.current = requestAnimationFrame(() => {
                const bannerTop = bannerRef.current.offsetTop;
                const bannerHeight = bannerRef.current.offsetHeight;
                const scrollTop = window.scrollY;
                const scrollBottom = scrollTop + window.innerHeight;

                // check if the banner is in view
                if (scrollTop < bannerTop + bannerHeight && scrollBottom > bannerTop) {
                    const progress = (scrollBottom - bannerTop) / (bannerHeight + window.innerHeight);
                    setScrollPosition(progress);
                } else {
                    setScrollPosition(0);
                }
            });
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cancelAnimationFrame(requestRef.current);
        };

        callAPI();

    }, []);

    const titleStyle = {
        background: `linear-gradient(to left, #00EA00 ${scrollPosition * 180}%, transparent 0)`,
    };

    return (
        <div ref={bannerRef} className={styles.birthdayContainer}>
            <div className={styles.describContainer}>
                <div className={styles.titleContaoner}>
                    <h2 style={titleStyle} id={styles.birthTitle}>مدرسه ترامپولین</h2>
                </div>
                <p id={styles.birthParagraph}>
                جایی برای آموزش حرفه‌ای پرش، صخره نوردی و ژیمناستیک، دوره‌های فیتنس و لاغری روی ترامپولین و کلاس‌های ویژه کودکان
                <p>{apiResponse}</p>
                </p>
               
            </div>
            <div className={styles.birthimgContainer} style={{ overflow: 'hidden' }}>
                <img className={styles.birthimg}  src={school} alt="birthday" />
            </div>
        </div>
    );
};

export default Birthday;


